module.exports = __webpack_public_path__ + "static/img/asiana-cs-competition.80b1944.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/asiana-cs-competition.jpg
// module id = 34Kc
// module chunks = 0